import React from "react"
import { graphql } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { CenterHoursDay } from "./center-hours-day/CenterHoursDay"
import { DownloadButton } from "../../button/download-button/DownloadButton"
import { Text } from "../../Text/Text"


interface OwnProps {
  centerHours: {
    monday: {
      opensAt: string;
      closesAt: string;
    },
    tuesday: {
      opensAt: string;
      closesAt: string;
    },
    wednesday: {
      opensAt: string;
      closesAt: string;
    },
    thursday: {
      opensAt: string;
      closesAt: string;
    },
    friday: {
      opensAt: string;
      closesAt: string;
    },
    saturday: {
      opensAt: string;
      closesAt: string;
    },
    sunday: {
      opensAt: string;
      closesAt: string;
    }
  };
}

export type CenterHoursProps = OwnProps

export const CenterHours: React.FC<CenterHoursProps> = ({
  centerHours
}) => {
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.center_hours",
  });

  return (
    <div className="bg-light-wool">
      <div className="max-w-content-width mx-auto px-5 py-8 md:py-16 md:grid md:grid-cols-2 md:gap-28">
        <div>
          <Text variant="medium-header">{t("title")}</Text>
          <div className="mt-2 mt-7">
            <Text variant="body">{t("intro")}</Text>
          </div>
          <div className="mt-5 md:mt-7 hidden md:block">
            <DownloadButton text={t("button_text")} href="/app/" variant="primary-button-sky" />
          </div>
        </div>
        <div className="text-left mt-7 mt-0">
          <Text variant="body">
            {Object.entries(centerHours).map(([key, value]) => {
                return (
                  <CenterHoursDay day={key} key={key} {...value} />
                )
              })
            }
          </Text>
        </div>
        <div className="mt-5 md:mt-7 md:hidden">
          <DownloadButton text={t("button_text")} href="/app/" variant="primary-button-sky" />
        </div>
      </div>
    </div>
  )
}
